import React from "react";
import { motion } from "framer-motion";
import { FlaskConical, Atom, DatabaseZap } from "lucide-react";

const UnlockingIntelligence: React.FC = () => {
  return (
    <section className="py-12">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-50px" }}
        transition={{ duration: 0.6, ease: "easeOut" }}
        className="mb-10 text-center"
      >
        <p className="text-xs uppercase tracking-widest text-white/40 mb-3">
          Why Data Revival
        </p>
        <h2 className="text-3xl font-semibold tracking-tight text-white md:text-4xl mb-4">
          The hidden intelligence in your chemical data
        </h2>
        <p className="text-white/60 text-base leading-relaxed max-w-2xl mx-auto">
          Vast volumes of valuable scientific data often lie dormant, locked
          away in legacy systems, spreadsheets, and lab notebooks. We've built a
          breakthrough suite of tools to revive and unify that data.
        </p>
      </motion.div>

      <motion.div
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-50px" }}
        transition={{ duration: 0.6, delay: 0.2, ease: "easeOut" }}
        className="flex flex-wrap justify-center gap-2"
      >
        <div className="flex items-center gap-2 px-4 py-2 rounded-full border border-white/10 hover:border-[#00A3FF]/40 transition-colors duration-200">
          <FlaskConical className="w-4 h-4 text-[#00A3FF]" strokeWidth={1.5} />
          <span className="text-white/60 text-xs">Lab Data Extraction</span>
        </div>
        <div className="flex items-center gap-2 px-4 py-2 rounded-full border border-white/10 hover:border-[#00A3FF]/40 transition-colors duration-200">
          <Atom className="w-4 h-4 text-[#00A3FF]" strokeWidth={1.5} />
          <span className="text-white/60 text-xs">
            Chemical Structure Recognition
          </span>
        </div>
        <div className="flex items-center gap-2 px-4 py-2 rounded-full border border-white/10 hover:border-[#00A3FF]/40 transition-colors duration-200">
          <DatabaseZap className="w-4 h-4 text-[#00A3FF]" strokeWidth={1.5} />
          <span className="text-white/60 text-xs">Semantic Linking</span>
        </div>
      </motion.div>
    </section>
  );
};

export default UnlockingIntelligence;
